import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const setEmailRegistRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo/userEmail') }
// const setDefaultLanguage = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo/language') }
const setProfileRegistRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo/userEmail') }
const setProfileRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo') }
const setFeelingRef = (currentUserId) => { return db.ref('users/' + currentUserId + '/userInfo/userFeeling') }
const removeUserRef = (targetUid) => { return db.ref('users/' + targetUid) }

export const profilesModule = {
  namespaced: true,
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.SET_DEFAULT_USER_INFO]: firebaseAction((context, value) => {
      setEmailRegistRef(context.rootState.currentUserId).set(value)
    }),
    [getterConstants.SET_NEW_PROFILE]: firebaseAction((context, value) => {
      setProfileRegistRef.set(value)
    }),
    [getterConstants.SET_PROFILE]: firebaseAction((context, value) => {
      setProfileRef(context.rootState.currentUserId).set(value)
    }),
    [getterConstants.SET_FEELING]: firebaseAction((context, value) => {
      setFeelingRef(context.rootState.currentUserId).set(value)
    }),
    [getterConstants.REMOVE_USER]: firebaseAction((context, value) => {
      removeUserRef(value).remove()
    })
  }
}



// WEBPACK FOOTER //
// ./src/stores/profiles.js